<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/print/record/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yewuleixing')">
            <yi_dictionary_select :max="999" clearable :type="'BUSINESS_TYPE'" :ids.sync="yt.conditions.businessTypes" disabled> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="item.label" v-for="item in searchs">
            <yi_dictionary_select :max="999" clearable :type="item.key" :ids.sync="yt.conditions[item.prop]" v-if="item.type === 'dictionary'"> </yi_dictionary_select>
            <el-input v-else v-model="yt.conditions[item.prop]" size="mini" clearable></el-input>
          </el-form-item>

          <el-form-item :label="$t('youxiaozhuangtai')">
            <yi_dictionary_select :max="1" clearable :type="'LABEL_VALID_STATUS'" :ids.sync="yt.conditions.validStatus"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ businessTypes: '13', notSearchFlag: false, orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_label_management_print_record_invalidate')" size="mini" type="danger" @click="invalidateRecords" :loading="invalidateRecordsLoading" :disabled="ids.length <= 0">
          {{ $t('zuofei') }}
        </el-button>

        <el-button v-if="utils.checkPower('web_base_label_management_print_record_batchReprint')" size="mini" @click="standardBatchReprintValidate" type="primary" :loading="batchReprintLoading" :disabled="printObjList.length <= 0">
          {{ $t('piliangchongxindayin') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" :loading="scope.row.rePrintLoading" @click="resetPrint(scope.row)"
              ><!-- 因为有selectionChange所以@click要换成@click.native.stop-->
              {{ $t('chongxindayin') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog class="standard-print-dialog" @close="closeStandardPrintDialog" :visible.sync="isShowStandardPrintLabel" append-to-body="append-to-body" width="800px">
      <div v-if="isShowStandardPrintLabel">
        <el-form :inline="true" ref="form" size="mini" label-width="150px">
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-select @change="change" v-model="printTemplateId" placeholder="请选择">
              <el-option v-for="printTemplate in printTemplateList" :label="printTemplate.name" :value="printTemplate.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <yi_print_preview v-if="printTemplateId" :printTemplateId.sync="printTemplateId" :printDatas="printDatas" ref="mixtureOrderTagPrint" :scale="4"></yi_print_preview>
        <div style="text-align: center;padding: 20px 0;">
          <el-button @click="closeStandardPrintDialog" style="width: 130px;">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" @click="standardPrint" style="width: 130px;">{{ $t('dayin') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'web_material_management_mixture_tag',
  data() {
    return {
      ids: [],
      isBatch: false,
      rePrintLoading: false,
      invalidateRecordsLoading: false,
      isShowStandardPrintLabel: false,
      batchReprintLoading: false,
      printTemplateId: null,
      searchs: [],
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'yewuleixing',
          prop: 'businessType',
          type: 'dictionary',
          key: 'BUSINESS_TYPE',
          width: 150
        },
        {
          label: 'biaoqqiantiaoma',
          prop: 'labelBarcodeNumber',
          width: 150
        },
        {
          label: 'picihao',
          prop: 'batchNo',
          width: 150
        },
        {
          label: 'baozhuangshuliang',
          prop: 'packageNumber',
          width: 150
        },
        {
          label: 'biaoqianzongshu',
          prop: 'labelTotalNumber',
          width: 150
        },
        {
          label: 'dangqianshunxu',
          prop: 'currentOrder',
          width: 150
        },

        {
          label: 'dayinren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'dayinshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'youxiaozhuangtai',
          prop: 'validStatus',
          type: 'dictionary_tag',
          key: 'LABEL_VALID_STATUS'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      printObj: {},
      printTemplateList: [],
      printData: {},
      printDatas: [],
      printObjList: []
    };
  },
  created() {
    this.yt.conditions.businessTypes = '13';
    setTimeout(() => {
      //获取配置列
      this.getColumsConfig();
      this.yt.conditions.businessTypes = '13';
      this.yt.conditions.notSearchFlag = false;
      this.yt.conditions.orderBy = 'createTime desc';
      this.yt.get(1);

      this.http.get('/web/print/template/list/by/type', { params: { type: '2' } }).then(res => {
        let itemList = res.data;
        this.printTemplateList = itemList;
      });
    }, 300);
  },
  methods: {
    standardPrint() {
      if (this.isBatch) {
        this.http
          .post('/web/print/record/standardBatchReprint', this.printObjList)
          .then(res => {
            this.$refs.mixtureOrderTagPrint.print();
            this.$message.success(this.$t('chenggong'));
            setTimeout(() => {
              this.closeStandardPrintDialog();
            }, 500);
          })
          .catch(err => {
            this.$message.error(err);
            this.closeStandardPrintDialog();
          });
      } else {
        this.http
          .post('/web/print/record/reprint', this.printObj)
          .then(res => {
            this.$refs.mixtureOrderTagPrint.print();
            this.$message.success(this.$t('chenggong'));
            setTimeout(() => {
              this.closeStandardPrintDialog();
            }, 500);
          })
          .catch(err => {
            this.$message.error(err);
            this.closeStandardPrintDialog();
          });
      }
    },
    getColumsConfig() {
      this.http.get('web/table/attribute/setting/list', { params: { businessType: '13' } }).then(res => {
        if (res.data.length) {
          //过滤出表格配置
          let columsConfig = res.data.filter(item => {
            return item.displayFlag === 1;
          });
          let columLabels = [];
          columsConfig.forEach(item => {
            columLabels.push(item.attrDesc);
            if (item.dictionaryType) {
              this.columns.push({
                label: item.attrDesc,
                prop: item.attrField,
                width: 150,
                type: 'dictionary',
                key: item.dictionaryType
              });
            } else {
              this.columns.push({
                label: item.attrDesc,
                prop: item.attrField,
                width: 150
              });
            }
          });
          this.yt.setColumnsShow(columLabels);
          //过滤出查询条件
          let queryConfig = res.data.filter(item => {
            return item.searchFlag === 1;
          });
          queryConfig.forEach(item => {
            if (item.dictionaryType) {
              this.searchs.push({
                label: item.attrDesc,
                prop: item.attrField,
                type: 'dictionary',
                key: item.dictionaryType
              });
            } else {
              this.searchs.push({
                label: item.attrDesc,
                prop: item.attrField
              });
            }
          });
        }
      });
    },
    resetPrint(row) {
      this.isShowStandardPrintLabel = true;
      this.printObj = row;
      let formData = {
        quantity: this.printObj.packageNumber,
        cartonQuantity: 1,
        batchNo: this.printObj.batchNo,
        mixtureOrderId: this.printObj.orderId,
        notInsertFlag: true,
        labelBarcodeNumber: this.printObj.labelBarcodeNumber
      };
      this.http
        .post('/web/mixture/order/print', formData)
        .then(res => {
          this.printDatas = [];
          res.data.forEach(item => {
            this.printDatas.push(item);
          });
        })
        .catch(e => {
          this.$message.error(this.$t(e));
        });
    },
    closeStandardPrintDialog() {
      this.printObjList = [];
      this.isBatch = false;
      this.printDatas = [];
      this.printObj = {};
      this.printTemplateId = null;
      this.isShowStandardPrintLabel = false;
      this.yt.get();
    },
    change() {},
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
      this.printObjList = items;
      if (this.ids.length > 0) {
        this.checkDisabled = false;
        for (let i = 0; i < items.length; i++) {
          if (items[i]['status'] == 2) {
            this.checkDisabled = true;
            return;
          }
        }
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
        this.printObjList = [];
      }
    },
    //作废
    invalidateRecords() {
      this.invalidateRecordsLoading = true;
      let params = {
        ids: this.ids
      };
      this.http
        .post('/web/print/record/invalidate', params)
        .then(res => {
          this.invalidateRecordsLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.checkDisabled = true;
          this.yt.get(1);
        })
        .catch(error => {
          this.invalidateRecordsLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    standardBatchReprintValidate() {
      let params = {
        printRecodeId: this.ids
      };
      this.http.post('/web/mixture/order/batchReprint', params).then(res => {
        this.printDatas = res.data;
        this.isShowStandardPrintLabel = true;
        this.isBatch = true;
      });
    }
  }
};
</script>

<style lang="less"></style>
